import React from 'react';
import { LogoLoading } from 'ensightful-koala-ui';
import { styled } from '@mui/material';

import { Box, Container, Tabs } from 'shell/components';
import { CourseOverviewTab } from 'components/organisms/CourseDashboard';

const CustomBox = styled(Box)(({ theme }) => {
    return {
        padding: theme.spacing(4),
        minHeight: 'calc(100vh - 64px - 20px)',
        width: '100%',
        borderRadius: '6px',
        background: theme.palette.ensightful.shades[0],
    };
});

const Desktop = ({
    isLoading,
    activeCourse,
    role,
    project,
    numGroups,
    selectProject,
    setProjectSettings,

    tab,
    setTab,
    tabOptions,
}) => {
    if (isLoading) return <LogoLoading />;
    return (
        <Container device={'desktop'}>
            <CustomBox>
                {role === 'instructor' ? (
                    <Tabs aria-label={'select tab'} options={tabOptions} selected={tab} onChange={setTab} />
                ) : (
                    <CourseOverviewTab
                        device={'desktop'}
                        course={activeCourse}
                        role={role}
                        project={project}
                        numGroups={numGroups}
                        selectProject={selectProject}
                        setProjectSettings={setProjectSettings}
                    />
                )}
            </CustomBox>
        </Container>
    );
};

export default Desktop;
